<app-shared-popup [event_popup]="history_obs.asObservable()"></app-shared-popup>